export const TOGGLER_SIDEBAR = "TOGGLER_SIDEBAR";
